var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.$language.zhCN}},[_c('div',{class:`${_vm.$route.matched[0] ? _vm.$route.matched[0].name : ''}`,attrs:{"id":"App"}},[[(_vm.$route.matched[0] && _vm.$route.matched[0].name === 'User')?[_c('router-view')]:[_c('Header'),_c('div',{attrs:{"id":"Body"}},[_c('router-view')],1),_c('Footer')]]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }